import { LocalStorageKeys } from '@/types';
import { getAuthItem } from '@/plugins/auth-storage';
export default (function (_a) {
    var store = _a.store;
    var JWTKey = LocalStorageKeys.JWT;
    if (!getAuthItem(JWTKey)) {
        return;
    }
    var holidayList = store.getters['holiday/holidays'];
    if (!Object.keys(holidayList).length) {
        store.dispatch('holiday/fetchHolidays');
    }
});
